<template>
  <div>
    <div class="clearfix"></div>
    <div class="row">
      <div class="col-md-12 col-sm-12 col-xs-12">
		<div class="form-group">
			<div class="col-lg-12 col-md-12 text-center" v-if="!transactionData.msg">
				<h3>Please wait while we're verifying your payment</h3>
				<div style="width:40%; margin:0 auto;"><div class="spinner"></div></div>
			</div>
			<div class="col-lg-12 col-md-12 text-center" v-if="transactionData">
				<div class="" v-if="transactionData.msg === 'pending'">
				<h1><i class="fa fa-spinner" aria-hidden="true"></i></h1>
				<h1>PENDING</h1>
				Your payment is pending and needs to be completed before you can continue.<br/>
				</div>
				<div class="" v-if="transactionData.msg === 'paid'">
				<h1><i class="fa fa-check" aria-hidden="true"></i></h1>
				<h1>PAID</h1>
				Thank you! Your payment is completed.<br/>
				</div>
				<div class="" v-if="transactionData.msg === 'already_processed'">
				<h1><i class="fa fa-check" aria-hidden="true"></i></h1>
				<h1>ALREADY PROCESSED</h1>
				This payment is already processed. Please check your creditbalance or create a new payment.<br/>
				</div>
				<div class="" v-if="transactionData.msg === 'failed'">
				<h1><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></h1>
				<h1>ERROR</h1>
				The transaction failed or has been canceled. Please try again.<br/>
				</div>
				<div class="" v-if="transactionData.msg === 'canceled'">
					<h1><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></h1>
					<h1>CANCELED</h1>
					The transaction has been canceled. You need to create a new one to add credits.<br/>
				</div>
				<div class="" v-if="transactionData.msg === 'trx_does_not_exist'">
				<h1><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></h1>
				<h1>ERROR</h1>
				This transaction could not be found. Please create a new one, or send u a support ticket if this doesn't resolve your problem.<br/>
				</div><br/>
				<router-link :to="{name: 'Transactions'}" tag="a" class="btn btn-lg btn-primary"><i class="fas fa-arrow-circle-left"></i> Click here to go back to the transactions overview</router-link>
			</div>
			</div>
      </div>      
    </div>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
        transactionData: {},
        transactionCode: this.$route.params.transactioncode
    }
  },
  mounted: function () {

		var url_string = window.location.href;
		var url = new URL(url_string);
		var payerId = url.searchParams.get("token");
		var payerId = typeof (payerId) == 'undefined' || payerId == null ? url.searchParams.get("PayerID") : payerId;
		var payment_intent = url.searchParams.get("payment_intent");


		if (this.transactionCode) {
			Webservice.verifyTransaction(this.transactionCode, payerId, payment_intent).then((resp) => {
				this.transactionData = resp.data;
				if (resp.data) {
					return;
				}
			}).catch((error) => {
				swal('Whoops', 'Could not verify this payment, maybe it is canceled or it failed', 'warning');
			});
		} else {
			swal('Whoops', 'Could not verify this payment (transactioncode missing)', 'warning');
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Transactions/Verify.vue